const GetThemeColourByDefault = (
    colour: string,
    allowedThemeColours: string[] = ['black', 'white']
): string => {
    if (allowedThemeColours.includes(colour)) {
        return colour
    } else {
        return 'white'
    }
}

export default GetThemeColourByDefault
